import Profile from '../components/views/profile/Profile.vue'

const routes = [{
    path: '/profile',
    component: Profile,
    name: 'Profile',
    meta: {
        title: 'Profile'
    }
}]

export default routes


// WEBPACK FOOTER //
// ./src/routes/profile.route.js